import { jsx as _jsx } from "react/jsx-runtime";
import { PureComponent, Fragment } from "react";
class BaseListComponent extends PureComponent {
    hasFilter() {
        const { filterTerm, filterValidator } = this.props;
        return filterTerm && filterTerm != "" && filterValidator;
    }
    filterItems() {
        const { listData, filterValidator } = this.props;
        const filteredItems = [];
        listData.forEach((item)=>{
            if (filterValidator(item)) {
                filteredItems.push(item);
            }
        });
        return filteredItems;
    }
    getFilteredItems() {
        const { listData } = this.props;
        const filteredItems = this.hasFilter() ? this.filterItems() : listData;
        return filteredItems || [];
    }
    itemRenderer(item) {
        const { itemRenderer } = this.props;
        return itemRenderer ? itemRenderer(item) : item;
    }
    renderEmptyState() {
        const { emptyStateRenderer } = this.props;
        return emptyStateRenderer ? emptyStateRenderer() : "";
    }
    renderItems(items) {
        return items.map(this.itemRenderer);
    }
    render() {
        const items = this.getFilteredItems();
        return /*#__PURE__*/ _jsx(Fragment, {
            children: items.length > 0 ? this.renderItems(items) : this.renderEmptyState()
        });
    }
    constructor(props){
        super(props);
        this.itemRenderer = this.itemRenderer.bind(this);
    }
}
export { BaseListComponent as default };
